import ReactDOM from 'react-dom'
import App from './App'
import React from 'react'
import {} from '../src/components/i18next/i18n'

ReactDOM.render(<App />, document.getElementById('root'))